

let preguntasEscaleraNutricion = {
    1:{
        "pregunta": "1. ¿Cuáles de los siguientes líquidos contienen mayor cantidad de azúcares añadidos, que son tan perjudiciales para la salud?",
        "respuestas":{
            1:{
                respuesta: "Refrescos en cajitas, gaseosas.",
                tipo: true
                },
            2:{
                respuesta :"Aguas refrescantes e infusiones de frutas.",
                tipo: false
            },
            3: {
                respuesta: "Leche, yogurt, kumis.",
                tipo: false
            },
            4:{
                respuesta: "Jugos de frutas naturales, el agua.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "2. Si hablamos de alimentos que aportan calorías vacías, estamos haciendo referencia a los:",
        "respuestas":{
            1:{
                respuesta: "Productos que aportan mucha energía, pero muy pocos o ningún nutriente beneficioso para la salud.",
                tipo: true
                },
            2:{
                respuesta :"Alimentos que aportan muy poca energía.",
                tipo: false
            },
            3: {
                respuesta: "Alimentos que aportan muchos nutrientes y mucha energía.",
                tipo: false
            },
            4:{
                respuesta: "Productos de paquete que casi no tienen contenido en su interior (están vacíos).",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "3. Cuando vamos a realizar un jugo natural nutritivo, con frutas e incluso con hortalizas ¿es necesario añadirle azúcar a la preparación?",
        "respuestas":{
            1:{
                respuesta: "No es necesario porque frutas y hortalizas tienen dulzor y sabor natural.",
                tipo: true
                },
            2:{
                respuesta :"Sí, siempre.",
                tipo: false
            },
            3: {
                respuesta: "En algunas ocasiones.",
                tipo: false
            },
            4:{
                respuesta: "Siempre se debe agregar azúcar.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "4. Cuando sentimos que al jugo natural realizado con frutas le hace falta dulzor ¿cuáles de las siguientes alternativas pueden ser más saludables?",
        "respuestas":{
            1:{
                respuesta: "Elaborarlo con frutas más dulces o maduras como el banano, cereza, piña, oromiel o mango.",
                tipo: true
                },
            2:{
                respuesta :"Añadirle más azúcar morena.",
                tipo: false
            },
            3: {
                respuesta: "Añadir edulcorantes.",
                tipo: false
            },
            4:{
                respuesta: "Añadirle azúcar blanca.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "5. Seleccione los cuatro ingredientes saludables para una excelente hamburguesa:",
        "respuestas":{
            1:{
                respuesta: "Pan integral, filete de pollo a la plancha, piña en rodajas, lechuga.",
                tipo: true
                },
            2:{
                respuesta :"Pan blanco, tocineta, cebolla frita, salsas.",
                tipo: false
            },
            3: {
                respuesta: "Pan integral, lonchita de queso, tomate, tocineta.",
                tipo: false
            },
            4:{
                respuesta: "Pan blanco, carne de hamburguesa, salsas, ensalada de repollo.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "6. Las frutas y verduras brindan los siguientes beneficios en salud, EXCEPTO:",
        "respuestas":{
            1:{
                respuesta: "Elevan el azúcar en la sangre y aumentan los niveles de colesterol.",
                tipo: true
                },
            2:{
                respuesta :"Antioxidantes que previenen el envejecimiento celular y por ello, el cáncer de colon.",
                tipo: false
            },
            3: {
                respuesta: "Buen aporte de fibra que mantiene la salud intestinal.",
                tipo: false
            },
            4:{
                respuesta: "Vitaminas y minerales que previenen enfermedades cardiovasculares.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "7. Cuando realizamos una comida rápida SALUDABLE en casa, el guacamole casero puede servir como una alternativa diferente a las salsas tradicionales.",
        "respuestas":{
            1:{
                respuesta: "Sí, pero si se hace con solo aguacate, cebolla, limón y poca cantidad de sal.",
                tipo: true
                },
            2:{
                respuesta :"Sí, pero cuando el guacamole tiene mucha sal.",
                tipo: false
            },
            3: {
                respuesta: "No, porque se daña rápido.",
                tipo: false
            },
            4:{
                respuesta: "No, por que no es una salsa.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "8. Complete la frase: Para lograr una alimentación saludable, se recomienda el consumo de al menos ___ porciones de frutas y verduras al día.",
        "respuestas":{
            1:{
                respuesta: "5 porciones.",
                tipo: true
                },
            2:{
                respuesta :"2 porciones.",
                tipo: false
            },
            3: {
                respuesta: "3 porciones.",
                tipo: false
            },
            4:{
                respuesta: "1 porción.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "9. La limpieza y desinfección de los alimentos es importante para:",
        "respuestas":{
            1:{
                respuesta: "Eliminar microorganismos perjudiciales para la salud y prevenir enfermedades transmitidas por alimentos.",
                tipo: true
                },
            2:{
                respuesta :"Poner el alimento bonito y bien presentado.",
                tipo: false
            },
            3: {
                respuesta: "Para que los alimentos no ensucien la nevera.",
                tipo: false
            },
            4:{
                respuesta: "Para conservar las propiedades nutricionales de los alimentos.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "10. Si la fruta o verdura se encuentra picada o pelada, ¿esta se puede someter al proceso de limpieza y desinfección?",
        "respuestas":{
            1:{
                respuesta: "No.",
                tipo: true
                },
            2:{
                respuesta :"Sí, pero si se pica pequeña.",
                tipo: false
            },
            3: {
                respuesta: "Sí, pero si se hace en las mañanas.",
                tipo: true
            },
            4:{
                respuesta: "Ninguna de las anteriores.",
                tipo: true
            }
        }
    },
    11:{
        "pregunta": "11. ¿Cuál de los siguientes pasos NO corresponde al proceso de limpieza y desinfección?",
        "respuestas":{
            1:{
                respuesta: "Pele y pique la fruta o verdura.",
                tipo: true
                },
            2:{
                respuesta :"Introduzca los alimentos en la solución desinfectante y deje remojar 3 minutos.",
                tipo: false
            },
            3: {
                respuesta: "Con la esponja remueva la suciedad visible en la superficie del alimento.",
                tipo: false
            },
            4:{
                respuesta: "Enjuague los alimentos con agua limpia y seque con una toalla absorbente.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "12. A la hora de preparar los alimentos, ni el tiempo, ni el método de cocción importa, ya que nunca hay pérdidas de nutrientes en los alimentos cuando los cocinamos.",
        "respuestas":{
            1:{
                respuesta: "Falso",
                tipo: true
                },
            2:{
                respuesta :"Verdadero",
                tipo: false
            },
            3: {
                respuesta: "Depende",
                tipo: false
            },
            4:{
                respuesta: "Ninguna de las anteriores",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "13. Mencione cuál método de cocción puede ser utilizado para preparar un plátano saludable:",
        "respuestas":{
            1:{
                respuesta: "Cocido al vapor.",
                tipo: true
                },
            2:{
                respuesta :"Frito.",
                tipo: false
            },
            3: {
                respuesta: "Asado hasta que quede negrito.",
                tipo: false
            },
            4:{
                respuesta: "Estofado.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "14. ¿El consumo excesivo de sal y azúcar es necesario para mantener un estado de salud adecuado?",
        "respuestas":{
            1:{
                respuesta: "No, porque en exceso son perjudiciales y pueden generar enfermedades como hipertensión y/o diabetes.",
                tipo: true
                },
            2:{
                respuesta :"Sí, porque en exceso aportan otros nutrientes como vitaminas.",
                tipo: false
            },
            3: {
                respuesta: "Algunas veces, porque hay días en los que se necesita en mayor cantidades.",
                tipo: false
            },
            4:{
                respuesta: "Ninguna de las anteriores.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "15. El objetivo principal del “Proyecto Prevención conocido como Nanobiocáncer” que se ejecuta en la institución Educativa se centra principalmente en la prevención del:",
        "respuestas":{
            1:{
                respuesta: "Sobrepeso y la obesidad.",
                tipo: true
                },
            2:{
                respuesta :"Enfermedades de transmisión sexual.",
                tipo: false
            },
            3: {
                respuesta: "Enfermedades transmitidas por alimentos.",
                tipo: false
            },
            4:{
                respuesta: "El exceso de peso para prevenir el cáncer de colon",
                tipo: false
            }
        }
    },
}

let preguntasToboganNutricion = {
    1:{
        "pregunta": "16. Seleccione cuál o cuáles son los beneficios de disminuir el consumo de alimentos fritos o eliminar la fritura como método de cocción en casa.",
        "respuestas":{
            1:{
                respuesta: "Genera perdida de nutrientes importantes para el cuerpo.",
                tipo: false
                },
            2:{
                respuesta :"Disminuye el riesgo de padecer enfermedades del corazón, diabetes e hipertensión.",
                tipo: true
            },
            3: {
                respuesta: "Aumenta los niveles de grasa en la sangre, favoreciendo la salud de las venas y arterias.",
                tipo: false
            },
            4:{
                respuesta: "Disminuye el riesgo de padecer sobrepeso y obesidad, que predisponen enfermedades como el cáncer de colon.",
                tipo: true
            }
        }
    },
    2:{
        "pregunta": "17. Los antioxidantes son compuestos químicos presentes en muchos alimentos de origen natural, estos tienen propiedades beneficiosas para la salud y previenen o retrasan el daño de las células del cuerpo. Seleccione cuál de los alimentos o preparaciones tienen antioxidantes:",
        "respuestas":{
            1:{
                respuesta: "Las frutas y verduras.",
                tipo: true
                },
            2:{
                respuesta :"Las chocolatinas.",
                tipo: false
            },
            3: {
                respuesta: "Las papitas fritas y snacks.",
                tipo: false
            },
            4:{
                respuesta: "Las gaseosas y refrescos en cajita.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "18. Los productos ultraprocesados se caracterizan por tener nutrientes críticos (de riesgo) que favorecen la aparición de enfermedades crónicas como obesidad, diabetes, hipertensión y cáncer. Dichos componentes son:",
        "respuestas":{
            1:{
                respuesta: "Azúcares añadidos, grasa saturada y trans, sal/sodio, conservantes y endulzantes artificiales.",
                tipo: true
                },
            2:{
                respuesta :"Proteínas, carbohidratos, fibra y grasas.",
                tipo: false
            },
            3: {
                respuesta: "Vitaminas y minerales.",
                tipo: false
            },
            4:{
                respuesta: "Fibra, carbohidratos, sodio, potasio.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "19. ¿Cuáles de los siguientes son 3 productos comestibles ultraprocesados, cuyo consumo frecuente puede causar enfermedades para toda la vida?",
        "respuestas":{
            1:{
                respuesta: "Refrescos en caja, panzerotti, salchichón.",
                tipo: true
                },
            2:{
                respuesta :"Limón, panela, arepa.",
                tipo: false
            },
            3: {
                respuesta: "Pan artesanal, papa cocida, y limonada.",
                tipo: false
            },
            4:{
                respuesta: "Manzana, pera, aguacate.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "20. Seleccione de los siguientes enunciados, una de las razones por la que se deben consumir alimentos de origen natural, en vez de los productos ultra-procesados.",
        "respuestas":{
            1:{
                respuesta: "Porque los alimentos de origen natural contienen nutrientes esenciales como proteínas, carbohidratos, grasas, fibra, vitaminas y minerales para el correcto desarrollo y funcionamiento del organismo, mientras que los productos ultra-procesados contienen nutrientes críticos en exceso y aditivos que favorecen el sobrepeso, la obesidad y generan en enfermedades crónicas graves.",
                tipo: true
                },
            2:{
                respuesta :"Porque los alimentos de origen natural aportan nutrientes como las grasas saturadas y azúcares en exceso que favorecen el desarrollo cerebral.",
                tipo: false
            },
            3: {
                respuesta: "Porque los alimentos de origen natural no tienen los ingredientes que le echan a los productos ultra-procesados y el cuerpo necesita de ellos.",
                tipo: false
            },
            4:{
                respuesta: "Ninguna de las anteriores, ya que los productos ultraprocesados aportan beneficios más significativos que los alimentos de origen natural como la activación del organismo con los saborizantes y estimulantes, así como la saciedad rápida por la alta cantidad de grasa o de azúcar que contienen",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "21. La fibra es un nutriente presente en muchos alimentos de origen natural como las frutas, verduras, leguminosas, entre otros. Para que la fibra sea un nutriente que beneficie la salud intestinal y prevenga la aparición del cáncer de colon se debe consumir acompañada de:",
        "respuestas":{
            1:{
                respuesta: "Buena cantidad de agua ",
                tipo: true
                },
            2:{
                respuesta :"Productos ultraprocesados",
                tipo: false
            },
            3: {
                respuesta: "Recetas con que tengan exceso de sal y azúcar",
                tipo: false
            },
            4:{
                respuesta: "Recetas con que tengan exceso de sal y azúcar",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "22. Si el propósito es prevenir la obesidad toca evitar el consumo de:",
        "respuestas":{
            1:{
                respuesta: "Productos ultraprocesados.",
                tipo: true
                },
            2:{
                respuesta :"Leguminosas.",
                tipo: false
            },
            3: {
                respuesta: "Frutas y verduras.",
                tipo: false
            },
            4:{
                respuesta: "Arroz.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "23. La proteína es un nutriente muy importante que se debe consumir en una dieta saludable; este nutriente ayuda a reparar y a crear nuevas células en nuestro cuerpo, nos ayuda a mantener la masa muscular, y a tener defensas fuertes, entre otros beneficios. Si deseamos consumir alimentos con buena fuente de proteínas, deberíamos comer:",
        "respuestas":{
            1:{
                respuesta: "Alimentos de origen animal como carne, huevo y leche, y alimentos de origen vegetal como las leguminosas con cereales.",
                tipo: true
                },
            2:{
                respuesta :"Frutas, arroz y aceites de origen vegetal.",
                tipo: false
            },
            3: {
                respuesta: "Suplementos que venden en tiendas especializadas y en gimnasios.",
                tipo: false
            },
            4:{
                respuesta: "Productos ultraprocesados como los salchichones, carnes de hamburguesa y otros embutidos.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "24. Si en nuestra casa para el almuerzo no tenemos carne (proteína de origen animal) y queremos consumir un alimento que nos aporte proteínas ¿Es posible reemplazar la proteína de origen animal por la proteína vegetal? ",
        "respuestas":{
            1:{
                respuesta: "Sí, puede reemplazar con leguminosas pero se deben consumir con un cereal, para que sea una proteína completa.",
                tipo: true
                },
            2:{
                respuesta :"Falso, nunca se puede reemplazar la proteína.",
                tipo: false
            },
            3: {
                respuesta: "Sí, se puede reemplazar con frutas y verduras.",
                tipo: false
            },
            4:{
                respuesta: "Nunca se puede, porque la carne es fundamental en la alimentación.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "25. ¿Con cuál de los siguientes grupos de alimentos hay que consumir la proteína vegetal, para que sea una proteína completa?",
        "respuestas":{
            1:{
                respuesta: "Cereales. ",
                tipo: true
                },
            2:{
                respuesta :"Frutas.",
                tipo: false
            },
            3: {
                respuesta: "Grasas.",
                tipo: false
            },
            4:{
                respuesta: "Dulces.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "26. ¿Qué insumos necesitamos para hacer la desinfección de alimentos?",
        "respuestas":{
            1:{
                respuesta: "Hipoclorito, agua, esponja.",
                tipo: true
                },
            2:{
                respuesta :"Pela papas, agua, jabón de loza.",
                tipo: false
            },
            3: {
                respuesta: "Hipoclorito, esponjilla para brillar ollas, jabón de manos.",
                tipo: false
            },
            4:{
                respuesta: "Agua, esponjilla de brillar ollas, jabón de manos.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "27. Seleccione cuál de los siguientes enunciados es un beneficio del consumo de frutas y verduras.",
        "respuestas":{
            1:{
                respuesta: "Reducir el riesgo de padecer Enfermedades Crónicas como las cardiovasculares y el cáncer de colon.",
                tipo: true
                },
            2:{
                respuesta :"Elevar los niveles de azúcar en sangre.",
                tipo: false
            },
            3: {
                respuesta: "Contribuir con la desaparición de caries dental.",
                tipo: false
            },
            4:{
                respuesta: "Aumentar los niveles de colesterol en sangre.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "28. ¿Cuáles de los siguientes alimentos son fuentes de proteína de origen animal?",
        "respuestas":{
            1:{
                respuesta: "Carne, huevo, leche.",
                tipo: true
                },
            2:{
                respuesta :"Manzana, pera, lechuga.",
                tipo: false
            },
            3: {
                respuesta: "Leguminosas, frutas, cereales.",
                tipo: false
            },
            4:{
                respuesta: "Maní, almendras, semillas de girasol.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "29. ¿Cuál de las siguientes preparaciones se considera un refrigerio saludable?",
        "respuestas":{
            1:{
                respuesta: "Salpicón de frutas en su jugo, sin azúcar añadido.",
                tipo: true
                },
            2:{
                respuesta :"Perro caliente con ripio de papa, repollo y salsas.",
                tipo: false
            },
            3: {
                respuesta: "Empanadas hojaldradas con gaseosa.",
                tipo: false
            },
            4:{
                respuesta: "Galletas dulces de paquete con bebida de fruta en caja",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "30. ¿Cuál de los siguientes enunciados NO es verídico?",
        "respuestas":{
            1:{
                respuesta: "El consumo de productos ultraprocesados es necesario para mantener el adecuado funcionamiento del cuerpo, ya que hay que tener variedad en la dieta.",
                tipo: true
                },
            2:{
                respuesta :"Para mantener un peso saludable, reduzca el consumo de “productos ultraprocesados o de paquete”, comidas rápidas, gaseosas y bebidas azucaradas.",
                tipo: false
            },
            3: {
                respuesta: "El consumo de productos ultraprocesados son un factor de riesgo de deficiencias nutricionales, ya que estos alimentos aportan calorías vacías, es decir, son bajos en fibra, vitaminas y minerales.",
                tipo: false
            },
            4:{
                respuesta: "Para disminuir los riesgos de padecer Enfermedades Crónicas No Trasmisibles es necesario hacer actividad física y aumentar el consumo de frutas y verduras.",
                tipo: false
            }
        }
    },
    16:{
        "pregunta": "31. Sí tenemos una preparación de un plátano relleno con carne, queso, ensalada de mango, aguacate y limón ¿Cuáles ingredientes tienen más antioxidantes en esta receta?",
        "respuestas":{
            1:{
                respuesta: "Mango, limón, cebolla, aguacate.",
                tipo: true
                },
            2:{
                respuesta :"Mantequilla, carne, queso.",
                tipo: false
            },
            3: {
                respuesta: "Plátano y queso",
                tipo: false
            },
            4:{
                respuesta: "Mantequilla, plátano y agua.",
                tipo: false
            }
        }
    },
}

let preguntasTurnoExtraNutricion = {
    1:{
        "pregunta": "32. Cuáles son algunas funciones de las proteínas:",
        "respuestas":{
            1:{
                respuesta: "Sirven para la reparación celular, mantenimiento de los tejidos del cuerpo y como transporte de nutrientes.",
                tipo: true
                },
            2:{
                respuesta :"Ayudan a la acumulación de grasa en el cuerpo y eleva los niveles de colesterol.",
                tipo: false
            },
            3: {
                respuesta: "Previenen el envejecimiento celular y mantiene la salud ósea.",
                tipo: false
            },
            4:{
                respuesta: "Es la encargada de darle solubilidad a la grasa",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "33. ¿Qué son las proteínas?",
        "respuestas":{
            1:{
                respuesta: "Son un macronutriente que está compuesto de aminoácidos unidos y desempeñan múltiples funciones vitales en el cuerpo.",
                tipo: true
                },
            2:{
                respuesta :"Son moléculas que funcionan como principal fuente de energía para el cuerpo.",
                tipo: false
            },
            3: {
                respuesta: "Son las grasas que consumimos en el aguacate, y en las nueces y semillas.",
                tipo: false
            },
            4:{
                respuesta: "Son moléculas antioxidantes que disminuyen el deterioro celular.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "34. ¿Elija beneficios que trae el consumo de fibra?",
        "respuestas":{
            1:{
                respuesta: "Ayuda a mantener la salud intestinal porque elimina los desechos de la digestión.",
                tipo: true
                },
            2:{
                respuesta :"Ayuda a la saciedad y por ello previene la obesidad.",
                tipo: true
            },
            3: {
                respuesta: "Es importante para el descanso y el sueño.",
                tipo: false
            },
            4:{
                respuesta: "Aporta a la salud de los músculos y de los huesos.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "35. Además de ser buena fuente de vitaminas y minerales, en general las frutas y las verduras también son buena fuente de:",
        "respuestas":{
            1:{
                respuesta: "Fibra.",
                tipo: true
                },
            2:{
                respuesta :"Proteínas.",
                tipo: false
            },
            3: {
                respuesta: "Azúcares añadidos.",
                tipo: false
            },
            4:{
                respuesta: "Grasas.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "36. ¿Cuáles de los siguientes alimentos se encuentran en el grupo de las leguminosas?",
        "respuestas":{
            1:{
                respuesta: "Lentejas, frijoles, arvejas, garbanzos.",
                tipo: true
                },
            2:{
                respuesta :"Maní, almendras, pistachos.",
                tipo: false
            },
            3: {
                respuesta: "Arroz, maíz, trigo.",
                tipo: false
            },
            4:{
                respuesta: "Papa, yuca, plátanos, ñame.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "37. Cuando no hay carne para una comida principal de los siguientes alimentos ¿Con cuáles sería más saludable, reemplazarla?",
        "respuestas":{
            1:{
                respuesta: "Lentejas, frijoles, arvejas o garbanzos, con arroz.",
                tipo: true
                },
            2:{
                respuesta :"Salchichón, jamón o mortadela.",
                tipo: false
            },
            3: {
                respuesta: "Atún enlatado, frijoles enlatadoso salchichas.",
                tipo: false
            },
            4:{
                respuesta: "No hay manera de reemplazarla por las anteriores opciones.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "38. Son tres beneficios de consumir leguminosas:",
        "respuestas":{
            1:{
                respuesta: "Tienen fibra, facilitan la digestión y por ello previenen el cáncer de colon.",
                tipo: true
                },
            2:{
                respuesta :"Son dulces, duran mucho y ayudan a la hidratación.",
                tipo: false
            },
            3: {
                respuesta: "Dan saciedad, son poco costosas aunque difíciles de conseguir.",
                tipo: false
            },
            4:{
                respuesta: "Tienen fibra, ayudan a eliminar las grasas y dan energía.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "39. ¿Cuál de los siguientes enunciados es el correcto?",
        "respuestas":{
            1:{
                respuesta: "Ninguno es correcto.",
                tipo: true
                },
            2:{
                respuesta :"Tener hábitos de alimentación saludable en casa es difícil porque los productos saludables son muy costosos y difíciles de conseguir.",
                tipo: false
            },
            3: {
                respuesta: "Una alimentación variada está compuesta por todos los alimentos, tanto los naturales como los ultraprocesados y se deben consumir por igual para equilibrar.",
                tipo: false
            },
            4:{
                respuesta: "Consumir frutas y verduras en la noche no es adecuado, ya que sube los niveles de azúcar en la sangre y no permite el buen descanso.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "40. ¿Cuáles de las siguientes prácticas son poco saludables y favorecen el desperdicio de nutrientes y de fibra cuando preparamos un jugo natural con fruta?",
        "respuestas":{
            1:{
                respuesta: "Añadirle azúcar, colar el jugo.",
                tipo: true
                },
            2:{
                respuesta :"Realizarlo con agua y prepararlo con fruta de cosecha.",
                tipo: false
            },
            3: {
                respuesta: "No colar el jugo y no añadirle azúcar.",
                tipo: false
            },
            4:{
                respuesta: "Ninguna de las anteriores.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "41. Cuando mencionamos que una alimentación es moderada, hacemos referencia a:",
        "respuestas":{
            1:{
                respuesta: "Que no contiene excesos de nutrientes críticos como las grasas saturadas, la sal y el azúcar.",
                tipo: true
                },
            2:{
                respuesta :"Que contiene poca cantidad de grasas saturadas u otras perjudiciales como las llamadas grasas trans",
                tipo: false
            },
            3: {
                respuesta: "Que contiene variedad de alimentos tanto de origen animal como de origen vegetal.",
                tipo: false
            },
            4:{
                respuesta: "Que los alimentos se encuentran limpios y su consumo no implica algún riesgo para la salud.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "42. De las siguientes preparaciones para una comida, cuál considera que tiene una buena variedad de grupos de alimentos, y cumple con el criterio de saludable:",
        "respuestas":{
            1:{
                respuesta: "Plato de pollo asado, arroz, ensalada de verduras y frutas, plátano cocido y agua refrescante de frutas.",
                tipo: true
                },
            2:{
                respuesta :"Galletas con mantequilla, salchicha picada, arepa y quesito.",
                tipo: false
            },
            3: {
                respuesta: "Ponqué de arequipe con yogurt comercial y  hojuelas de avena.",
                tipo: false
            },
            4:{
                respuesta: "Cereales azucarados con leche chocolatada y banano.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "43. Seleccione cuál es el beneficio de tener una alimentación variada y consumir platos coloridos con frutas y verduras:",
        "respuestas":{
            1:{
                respuesta: "Disminuye el riesgo de tener deficiencias de vitaminas y minerales, que ayudan a mantener las funciones de manera correcta en el organismo.",
                tipo: true
                },
            2:{
                respuesta :"No tiene ningún beneficio ya que la alimentación siempre debe ser la misma.",
                tipo: false
            },
            3: {
                respuesta: "Aumenta la probabilidad de sufrir alteraciones en el colon y en el torrente sanguíneo.",
                tipo: false
            },
            4:{
                respuesta: "Disminuye el riesgo de padecer enfermedades transmitidas por alimentos.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "44. Seleccione que beneficios trae el consumo de frutas y verduras:",
        "respuestas":{
            1:{
                respuesta: "Aporta vitaminas y minerales que ayudan a prevenir el envejecimiento de las células, fortalecen el sistema inmune y previenen el cáncer.",
                tipo: true
                },
            2:{
                respuesta :"Proporciona suficiente energía para realizar actividades de alta intensidad y dan saciedad.",
                tipo: false
            },
            3: {
                respuesta: "Favorece la acumulación de sustancias benéficas en el hígado, ayudan a la hidratación de los músculos y a la recuperación celular.",
                tipo: false
            },
            4:{
                respuesta: "Ayuda a mantener las reservas de energía grasa, previenen el hambre y mejoran la fermentación del azúcar.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "45. En el batido de frutos amarillos encontramos una buena cantidad de fibra, vitaminas A, B y C, y estas ayudan a prevenir muchas enfermedades como el cáncer de colon. ¿Qué trilogía de frutas se puede incluir en la preparación de un batido de frutos amarillos?",
        "respuestas":{
            1:{
                respuesta: "Mango, banano, maracuyá.",
                tipo: true
                },
            2:{
                respuesta :"El banano, fresas y pepino.",
                tipo: false
            },
            3: {
                respuesta: "Mango, piña y kiwi.",
                tipo: false
            },
            4:{
                respuesta: "Manzana, pera, mora.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "46. Complete la frase: una alimentación es _______ cuando incluye los alimentos que contienen vitaminas, minerales, fibra y energía recomendada por edad y condición, para cumplir con las funciones deldía a día de la persona.",
        "respuestas":{
            1:{
                respuesta: "Adecuada.",
                tipo: true
                },
            2:{
                respuesta :"Orgánica",
                tipo: false
            },
            3: {
                respuesta: "Poco saludable.",
                tipo: false
            },
            4:{
                respuesta: "Rica.",
                tipo: false
            }
        }
    },
}



//Preguntas Tema Nutricion-2_________________________________________________________________________________________________________

let preguntasEscaleraNutricion2 = {
    1:{
        "pregunta": "1. ¿Cuál de los siguientes alimentos se considera que es procesados o altamente procesados?",
        "respuestas":{
            1:{
                respuesta: "Galletas rellenas de crema.",
                tipo: true
                },
            2:{
                respuesta :"Leche fresca.",
                tipo: false
            },
            3: {
                respuesta: "Yogur natural.",
                tipo: false
            },
            4:{
                respuesta: "Pera.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "2. ¿Por qué deberías limitar el consumo de bebidas azucaradas?",
        "respuestas":{
            1:{
                respuesta: "Para evitar el aumento de peso corporal.",
                tipo: true
                },
            2:{
                respuesta :"Porque son deliciosas.",
                tipo: false
            },
            3: {
                respuesta: "Porque son muy baratas.",
                tipo: false
            },
            4:{
                respuesta: "Porque son nutritivas.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "3. ¿Cuál es un efecto negativo de consumir una dieta alta en productos procesados y altamente procesados?",
        "respuestas":{
            1:{
                respuesta: "Aumento de peso y riesgo de enfermedades como la diabetes.",
                tipo: true
                },
            2:{
                respuesta :"Pérdida de peso.",
                tipo: false
            },
            3: {
                respuesta: "Aumento de energía y vitalidad.",
                tipo: false
            },
            4:{
                respuesta: "Mayor salud.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "4. ¿Por qué es importante revisar las etiquetas de los alimentos antes de comprarlos?",
        "respuestas":{
            1:{
                respuesta: "Para saber qué ingredientes contiene y su calidad nutricional. ",
                tipo: true
                },
            2:{
                respuesta :"Para encontrar chistes divertidos.",
                tipo: false
            },
            3: {
                respuesta: "Para ver si el empaque es bonito.",
                tipo: false
            },
            4:{
                respuesta: "Para saber en qué lugar del mundo lo hicieron.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "5. ¿Qué alternativa es más saludable para un almuerzo?",
        "respuestas":{
            1:{
                respuesta: "Una ensalada casera con arroz y pollo o huevo.",
                tipo: true
                },
            2:{
                respuesta :"Comida empaquetadas.",
                tipo: false
            },
            3: {
                respuesta: "Pizza congelada con embutidos.",
                tipo: false
            },
            4:{
                respuesta: "Un panzerotti frito relleno de salchicha.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "6. ¿Por qué debes moderar el consumo de alimentos fritos y grasas saturadas?",
        "respuestas":{
            1:{
                respuesta: "Para mantener un corazón saludable y reducir el riesgo de enfermedades cardíacas.",
                tipo: true
                },
            2:{
                respuesta :"No importa, puedes comerlos todo el tiempo.",
                tipo: false
            },
            3: {
                respuesta: "Porque son difíciles de encontrar.",
                tipo: false
            },
            4:{
                respuesta: "Porque son deliciosos.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "7. ¿Cuál es un consejo para reducir el consumo de alimentos ultraprocesados?",
        "respuestas":{
            1:{
                respuesta: "Cocinar comidas caseras con alimentos naturales.",
                tipo: true
                },
            2:{
                respuesta :"Comprar más comida rápida.",
                tipo: false
            },
            3: {
                respuesta: "Comer solo alimentos enlatados.",
                tipo: false
            },
            4:{
                respuesta: "Comprarlos en el supermercado.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "8. ¿Cuál es el efecto de consumir productos procesados y altamente procesados en tu energía?",
        "respuestas":{
            1:{
                respuesta: "Puede hacerte sentir cansado y sin energía.",
                tipo: true
                },
            2:{
                respuesta :"Te dará más energía.",
                tipo: false
            },
            3: {
                respuesta: "No tiene ningún efecto en tu energía.",
                tipo: false
            },
            4:{
                respuesta: "Te hace feliz.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "9. ¿Por qué es importante limitar el consumo de alimentos con alto contenido de sodio?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una presión arterial saludable y reducir el riesgo de hipertensión.",
                tipo: true
                },
            2:{
                respuesta :"Porque no afecta la salud.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos son iguales en sodio.",
                tipo: false
            },
            4:{
                respuesta: "Porque el sodio alimenta más.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "10. ¿Por qué es importante saber qué ingredientes están en tu comida?",
        "respuestas":{
            1:{
                respuesta: "Para tomar decisiones alimentarias informadas y evitar ingredientes innecesarios que en exceso pueden afectar negativamente la salud.",
                tipo: true
                },
            2:{
                respuesta :"Porque es divertido.",
                tipo: false
            },
            3: {
                respuesta: "Porque no importa lo que comas.",
                tipo: false
            },
            4:{
                respuesta: "Porque podemos comer lo mismo siempre y no importa.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "11. ¿Por qué deberías comer más alimentos naturales?",
        "respuestas":{
            1:{
                respuesta: "Para asegurarte de obtener los nutrientes necesarios para crecer y desarrollarte saludablemente.",
                tipo: true
                },
            2:{
                respuesta :"Porque son más baratos.",
                tipo: false
            },
            3: {
                respuesta: "Porque son más sabrosos.",
                tipo: false
            },
            4:{
                respuesta: "Porque son empaquetados.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "12. ¿Por qué debes aumentar el consumo de alimentos naturales y mínimamente procesados?",
        "respuestas":{
            1:{
                respuesta: "Para garantizar que consumo alimentos que me proporcionan nutrientes importantes que favorecen mi salud.",
                tipo: true
                },
            2:{
                respuesta :"Porque los alimentos sin nutrientes son los más deliciosos.",
                tipo: false
            },
            3: {
                respuesta: "Porque no hay diferencia en lo que comes.",
                tipo: false
            },
            4:{
                respuesta: "Porque casi no alimentan.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": '13. ¿Qué significa "comer en moderación" cuando se trata de productos procesados y altamente procesados?',
        "respuestas":{
            1:{
                respuesta: "Comer en pequeñas cantidades de vez en cuando.",
                tipo: true
                },
            2:{
                respuesta :"Comer todos los días.",
                tipo: false
            },
            3: {
                respuesta: "Comer en grandes cantidades.",
                tipo: false
            },
            4:{
                respuesta: "Comer hasta que no haya un mañana.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "14. ¿Cuál es una buena alternativa a las papas fritas altamente procesadas?",
        "respuestas":{
            1:{
                respuesta: "Optar por aperitivos más saludables como palitos de zanahoria u otras frutas.",
                tipo: true
                },
            2:{
                respuesta :"Comer papas fritas todos los días.",
                tipo: false
            },
            3: {
                respuesta: "No importa lo que comas.",
                tipo: false
            },
            4:{
                respuesta: "Un palito de queso frito con salsa rosada.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "15. ¿Por qué es importante cuidar tu piel y cabello eligiendo alimentos saludables? ",
        "respuestas":{
            1:{
                respuesta: "Para mantener una piel y un cabello saludables y radiantes.",
                tipo: true
                },
            2:{
                respuesta : "Porque no afecta tu apariencia.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos lucen igual.",
                tipo: false
            },
            4:{
                respuesta: "Eso no importa.",
                tipo: false
            }
        }
    },
}

let preguntasToboganNutricion2 = {
    1:{
        "pregunta": "16. ¿Qué puedes hacer para reducir el deseo de consumir productos procesados y altamente procesados? ",
        "respuestas":{
            1:{
                respuesta: "Gradualmente reducir su consumo y reemplazarlos con opciones más saludables.",
                tipo: true
                },
            2:{
                respuesta : "Comer más alimentos ultraprocesados.",
                tipo: false
            },
            3: {
                respuesta: "No puedes hacer nada al respecto.",
                tipo: false
            },
            4:{
                respuesta: "Gradualmente aumentar el consumo.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "17. ¿Por qué es importante elegir alimentos naturales en lugar de aquellos con ingredientes artificiales?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una dieta más natural y saludable.",
                tipo: true
                },
            2:{
                respuesta : "Porque los sabores artificiales son más divertidos.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos saben igual.",
                tipo: false
            },
            4:{
                respuesta: "Porque es igual todo.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "18. ¿Por qué es importante cuidar tus dientes y evitar el consumo excesivo de azúcares?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una sonrisa saludable y evitar problemas dentales.",
                tipo: true
                },
            2:{
                respuesta :"Porque los dientes no importan.",
                tipo: false
            },
            3: {
                respuesta: "Porque no hay diferencia en lo que comes.",
                tipo: false
            },
            4:{
                respuesta: "Porque los azúcares cuidan los dientes.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "19. ¿Por qué es importante elegir alimentos naturales antes de un examen importante?",
        "respuestas":{
            1:{
                respuesta: "Para asegurarte de tener la energía y la concentración necesarias para rendir bien.",
                tipo: true
                },
            2:{
                respuesta :"Porque no importa lo que comas.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos son igualmente efectivos.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "20. ¿Por qué es importante cuidar tu sistema digestivo y elegir alimentos naturales?",
        "respuestas":{
            1:{
                respuesta: "Para evitar problemas digestivos y mantener un sistema digestivo saludable.",
                tipo: true
                },
            2:{
                respuesta :"Porque no importa cómo se siente tu estómago.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos son igualmente buenos para la digestión.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "21. ¿Por qué es importante limitar el consumo de aceites vegetales refinados?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una dieta más equilibrada y reducir el riesgo de enfermedades cardiovasculares.",
                tipo: true
                },
            2:{
                respuesta :"Porque no afecta tu salud.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los aceites son igualmente saludables.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "22. ¿Por qué es importante ser consciente de las porciones al comer alimentos ultraprocesados?",
        "respuestas":{
            1:{
                respuesta: "Para evitar el aumento de peso y mantener un peso saludable.  ",
                tipo: true
                },
            2:{
                respuesta :"Porque puedes comer tanto como quieras.",
                tipo: false
            },
            3: {
                respuesta: "Porque las porciones no importan.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "23. ¿Por qué es importante pensar en la salud a largo plazo cuando eliges tus alimentos?",
        "respuestas":{
            1:{
                respuesta: "Para asegurarte de tener una vida saludable y activa en el futuro.",
                tipo: true
                },
            2:{
                respuesta :"Porque la salud a largo plazo no importa.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos son igualmente buenos.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "24. ¿Por qué es importante controlar tu consumo de sodio?",
        "respuestas":{
            1:{
                respuesta: "Para mantener un equilibrio de líquidos saludable y evitar problemas de retención de agua.",
                tipo: true
                },
            2:{
                respuesta :"Porque no afecta tu cuerpo.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos tienen la misma cantidad de sodio.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "25. ¿Por qué es importante evitar los alimentos con aditivos?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una dieta más natural y saludable.",
                tipo: true
                },
            2:{
                respuesta :"Porque son más sabrosos.",
                tipo: false
            },
            3: {
                respuesta: "Porque no hay diferencia en lo que consumes.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "26. ¿Por qué es importante ser consciente de la posibilidad de desarrollar adicción a ciertos alimentos?",
        "respuestas":{
            1:{
                respuesta: "Para evitar la adicción y mantener un control saludable sobre tus elecciones alimenticias.",
                tipo: true
                },
            2:{
                respuesta :"Porque no importa si eres adicto a la comida.",
                tipo: false
            },
            3: {
                respuesta: "Porque la adicción a los alimentos no existe.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "27. ¿Por qué es importante mantener niveles de azúcar en sangre estables?",
        "respuestas":{
            1:{
                respuesta: "Para tener energía constante y evitar sentirte fatigado.",
                tipo: true
                },
            2:{
                respuesta :"Porque no importa cómo te sientas.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los niveles de azúcar son iguales.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "28. ¿Por qué es importante consumir suficiente fibra en tu dieta?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una digestión saludable y prevenir problemas como el estreñimiento.",
                tipo: true
                },
            2:{
                respuesta :"Porque no importa si tienes problemas de digestión.",
                tipo: false
            },
            3: {
                respuesta: "Porque la fibra no hace diferencia en tu digestión.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "29. ¿Por qué es importante elegir alimentos que te llenen y te proporcionen nutrientes?",
        "respuestas":{
            1:{
                respuesta: "Para evitar el hambre constante y tener suficiente energía.",
                tipo: true
                },
            2:{
                respuesta :"Porque no importa si tienes hambre todo el tiempo.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos son igualmente satisfactorios.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "30. ¿Cuál es una buena razón para evitar alimentos con grasas trans?",
        "respuestas":{
            1:{
                respuesta: "Mantener un corazón saludable y reducir el riesgo de enfermedades cardíacas.",
                tipo: true
                },
            2:{
                respuesta :"No importa cómo afecten tu corazón.",
                tipo: false
            },
            3: {
                respuesta: "Porque todas las grasas son igual de buenas para tu corazón.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
}

let preguntasTurnoExtraNutricion2 = {
    1:{
        "pregunta": "31. ¿Por qué es importante optar por comidas caseras con ingredientes naturales en lugar de ultraprocesados?",
        "respuestas":{
            1:{
                respuesta: "Para evitar ingredientes artificiales y mantener una alimentación más saludable.",
                tipo: true
                },
            2:{
                respuesta :"Porque los alimentos procesados son más sabrosos.",
                tipo: false
            },
            3: {
                respuesta: "Porque no importa lo que comas.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "32. Los productos procesados y altamente procesados se caracterizan por tener nutrientes de riesgo que favorecen la aparición de enfermedades crónicas como obesidad, diabetes, hipertensión y cáncer. Dichos componentes son:",
        "respuestas":{
            1:{
                respuesta: "Azúcares añadidos, grasa saturada y grasas trans, sal/sodio, endulzantes e ingredientes artificiales.",
                tipo: true
                },
            2:{
                respuesta :"Proteínas, carbohidratos, fibra y grasas.",
                tipo: false
            },
            3: {
                respuesta: "Vitaminas y minerales.",
                tipo: false
            },
            4:{
                respuesta: "Fibra, carbohidratos, sodio, potasio.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "33. ¿Por qué debes limitar el consumo de productos procesados y altamente procesados e incrementar el consumo de alimentos naturales?",
        "respuestas":{
            1:{
                respuesta: "Para asegurarte de que estás comiendo alimentos que te ayuden a crecer y mantenerte saludable.",
                tipo: true
                },
            2:{
                respuesta :"Porque los alimentos sin nutrientes son los más deliciosos.",
                tipo: false
            },
            3: {
                respuesta: "Porque no hay diferencia en lo que comes.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "34. ¿Por qué es importante ser consciente de tu consumo de azúcares añadidos?",
        "respuestas":{
            1:{
                respuesta: "Para mantener un peso saludable y evitar enfermedades como la diabetes.",
                tipo: true
                },
            2:{
                respuesta :"Porque no afecta tu salud.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos tienen la misma cantidad de azúcares.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "35. ¿Por qué es importante tener una alimentación equilibrada?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una mente sana y evitar cambios bruscos en el estado de ánimo.",
                tipo: true
                },
            2:{
                respuesta :"Porque no importa cómo te sientas mentalmente.",
                tipo: false
            },
            3: {
                respuesta: "Porque la alimentación no tiene efecto en tu salud mental.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "36. ¿Qué son los productos procesados y altamente procesados?",
        "respuestas":{
            1:{
                respuesta: "Alimentos a los que en su proceso se les adiciona ingredientes como sal, azúcar, aceites, endulzantes o ingredientes artificiales para prolongar su duración y hacerlos mas atractivos y deseables.",
                tipo: true
                },
            2:{
                respuesta :"Alimentos saludables.",
                tipo: false
            },
            3: {
                respuesta: "Alimentos altos en grasas.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "37. ¿Por qué es importante evitar alimentos con ingredientes artificiales?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una dieta más natural y saludable.",
                tipo: true
                },
            2:{
                respuesta :"Porque los sabores artificiales son más divertidos.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos saben igual.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "38. ¿Por qué es importante evitar los alimentos con ingredientes artificiales?",
        "respuestas":{
            1:{
                respuesta: "Para mantener una dieta más natural y saludable.",
                tipo: true
                },
            2:{
                respuesta :"Porque son más sabrosos.",
                tipo: false
            },
            3: {
                respuesta: "Porque no hay diferencia en lo que consumes.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "39. ¿El consumo excesivo de sal y azúcar es necesario para mantener un estado de salud adecuado?",
        "respuestas":{
            1:{
                respuesta: "No, porque en exceso son perjudiciales y pueden generar enfermedades como hipertensión y/o diabetes.",
                tipo: true
                },
            2:{
                respuesta :"Sí, porque en exceso aportan otros nutrientes como vitaminas.",
                tipo: false
            },
            3: {
                respuesta: "Algunas veces, porque hay días en los que se necesita en mayores cantidades .",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "40. Los productos procesados y altamente procesados se caracterizan por tener nutrientes de riesgo que aumentan el riesgo de aparición de enfermedades crónicas como obesidad, diabetes, hipertensión y cáncer. Dichos componentes son:",
        "respuestas":{
            1:{
                respuesta: "Azúcares añadidos, grasa saturada y trans, sal/sodio, endulzantes y aditivos artificiales.",
                tipo: true
                },
            2:{
                respuesta :"Proteínas, carbohidratos, fibra y grasas.",
                tipo: false
            },
            3: {
                respuesta: "Vitaminas y minerales.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "41. Seleccione de los siguientes enunciados, una de las razones por la que se deben consumir alimentos naturales, en vez de productos procesados y altamente procesados:",
        "respuestas":{
            1:{
                respuesta: "Porque los alimentos naturales contienen nutrientes esenciales como proteínas, carbohidratos, grasas, fibra, vitaminas y minerales para el correcto desarrollo y funcionamiento del organismo, mientras que los productos procesados y altamente procesados contienen nutrientes de riesgo en exceso que favorecen el sobrepeso, la obesidad yaumentan el riesgo de padecer enfermedades crónicas graves.",
                tipo: true
                },
            2:{
                respuesta :"Porque los alimentos de origen natural no tienen los ingredientes que le echan a los productos ultra-procesados y el cuerpo necesita de ellos.",
                tipo: false
            },
            3: {
                respuesta: "Porque los alimentos de origen natural aportan nutrientes como las grasas saturadas y azúcares en exceso que favorecen el desarrollo cerebral.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "42. ¿Por qué es importante pensar en la salud a largo plazo cuando eliges tus alimentos?",
        "respuestas":{
            1:{
                respuesta: "Para asegurarte de tener una vida saludable y activa en el futuro.",
                tipo: true
                },
            2:{
                respuesta :"Porque la salud a largo plazo no importa.",
                tipo: false
            },
            3: {
                respuesta: "Porque todos los alimentos son igualmente buenos.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "43. Si el propósito es prevenir la obesidad, es importante evitar el consumo de:",
        "respuestas":{
            1:{
                respuesta: "Productos procesados y altamente procesados .",
                tipo: true
                },
            2:{
                respuesta :"Leguminosas.",
                tipo: false
            },
            3: {
                respuesta: "Frutas y verduras.",
                tipo: false
            },
            4:{
                respuesta: "Arroz.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "44. Si hablamos de alimentos que aportan calorías vacías, estamos haciendo referencia a los:",
        "respuestas":{
            1:{
                respuesta: "Productos que aportan mucha energía, pero muy pocos o ningún nutriente beneficioso para la salud.",
                tipo: true
                },
            2:{
                respuesta :"Alimentos que aportan muy poca energía.",
                tipo: false
            },
            3: {
                respuesta: "Alimentos que aportan muchos nutrientes y mucha energía.",
                tipo: false
            },
            4:{
                respuesta: "Productos de paquete que casi no tienen contenido en su interior (están vacíos).",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "45. ¿Cuáles de las siguientes bebidas contienen mayor cantidad de azúcares añadidos, y consumidas en exceso pueden ser perjudiciales para la salud?",
        "respuestas":{
            1:{
                respuesta: "Refrescos y gaseosas.",
                tipo: true
                },
            2:{
                respuesta :"Leche, yogurt, kumis",
                tipo: false
            },
            3: {
                respuesta: "Aguas refrescantes e infusiones de frutas.",
                tipo: false
            },
            4:{
                respuesta: "Jugos de frutas naturales, el agua.",
                tipo: false
            }
        }
    },
}


let preguntasEscaleraNutricion3 = {
    1:{
        "pregunta": "1. ¿Qué elementos conforman una proteína?",
        "respuestas":{
            1:{
                respuesta: "Aminoácidos.",
                tipo: true
                },
            2:{
                respuesta :"Leguminosas.",
                tipo: false
            },
            3: {
                respuesta: "Vegetales.",
                tipo: false
            },
            4:{
                respuesta: "Grasas.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "2.	¿Qué tipos de proteína podemos encontrar en los alimentos?",
        "respuestas":{
            1:{
                respuesta: "Animal y vegetal.",
                tipo: true
                },
            2:{
                respuesta :"Vegetal y trascendental.",
                tipo: false
            },
            3: {
                respuesta: "Animal y vegetariana.",
                tipo: false
            },
            4:{
                respuesta: "Omnívora y carnívora.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "3.	¿Qué papel cumplen los aminoácidos en tu organismo?",
        "respuestas":{
            1:{
                respuesta: "Formación de tejidos como músculos, tendones y órganos.",
                tipo: true
                },
            2:{
                respuesta: "Permiten respirar mejor.",
                tipo: false
            },
            3: {
                respuesta: "Hacen que la piel sea de color oscuro.",
                tipo: false
            },
            4:{
                respuesta: "Nos tumban el cabello.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "4.	¿Qué es un aminoácido?",
        "respuestas":{
            1:{
                respuesta: "Una molécula que hace parte de las proteínas. ",
                tipo: true
                },
            2:{
                respuesta :"Una enfermedad hereditaria.",
                tipo: false
            },
            3: {
                respuesta: "Un producto que se consigue en la tienda.",
                tipo: false
            },
            4:{
                respuesta: "Un tipo de ultraprocesados.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "5.	¿Cómo se clasifican los aminoácidos?",
        "respuestas":{
            1:{
                respuesta: "Esenciales y no esenciales.",
                tipo: true
                },
            2:{
                respuesta :"De izquierda y derecha.",
                tipo: false
            },
            3: {
                respuesta: "Grandes y pequeños.",
                tipo: false
            },
            4:{
                respuesta: "Blancos y oscuros.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "6.	¿Por qué son importantes los aminoácidos en tu organismo?",
        "respuestas":{
            1:{
                respuesta: "Nos ayudan a reparar tejidos.",
                tipo: true
                },
            2:{
                respuesta :"Nos engordan.",
                tipo: false
            },
            3: {
                respuesta: "Nos dan mal olor.",
                tipo: false
            },
            4:{
                respuesta: "No permiten que crezcamos.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "7.	¿Qué preparaciones caseras de las leguminosas podemos hacer para obtener un mayor aporte proteico?",
        "respuestas":{
            1:{
                respuesta: "Frijoles y arroz.",
                tipo: true
                },
            2:{
                respuesta :"Jugos sin azúcar.",
                tipo: false
            },
            3: {
                respuesta: "Sopa de verduras.",
                tipo: false
            },
            4:{
                respuesta: "Sopa de zanahoria.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "8. ¿Qué es la proteína vegetal?",
        "respuestas":{
            1:{
                respuesta: "Proteína encontrada en las plantas o alimentos de origen vegetal.",
                tipo: true
                },
            2:{
                respuesta :"Proteína de origen animal.",
                tipo: false
            },
            3: {
                respuesta: "Proteína que solo se encuentra en las frutas.",
                tipo: false
            },
            4:{
                respuesta: "Proteína en alimentos procesados.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "9. ¿Cuál de los siguientes alimentos es una excelente fuente de proteína vegetal y se prepara con soja? ",
        "respuestas":{
            1:{
                respuesta: "Tofu.",
                tipo: true
                },
            2:{
                respuesta :"Pollo.",
                tipo: false
            },
            3: {
                respuesta: "Leche.",
                tipo: false
            },
            4:{
                respuesta: "Pescado.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "10. ¿Qué son las leguminosas?",
        "respuestas":{
            1:{
                respuesta: "Plantas que incluyen frijoles, arvejas, lentejas y garbanzos.",
                tipo: true
                },
            2:{
                respuesta :"Vegetales verdes.",
                tipo: false
            },
            3: {
                respuesta: "Frutas tropicales.",
                tipo: false
            },
            4:{
                respuesta: "Grupos de alimentos procesados.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "11. ¿Cuál de las siguientes leguminosas es una fuente común de proteína vegetal en Colombia?",
        "respuestas":{
            1:{
                respuesta: "Frijoles.",
                tipo: true
                },
            2:{
                respuesta :"Lentejas.",
                tipo: false
            },
            3: {
                respuesta: "Plátano.",
                tipo: false
            },
            4:{
                respuesta: "Brócoli.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "12. Según las Guías Alimentarias para la población colombiana, ¿cuántas veces se recomienda consumir leguminosas como frijoles, arvejas, lentejas o garbanzos a la semana?",
        "respuestas":{
            1:{
                respuesta: "Al menos dos veces por semana.",
                tipo: true
                },
            2:{
                respuesta :"Al menos una vez por semana.",
                tipo: false
            },
            3: {
                respuesta: "Al menos tres veces por semana.",
                tipo: false
            },
            4:{
                respuesta: "No se menciona en las guías.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "13. ¿Cuál es una forma económica de incorporar proteína vegetal en tu dieta?",
        "respuestas":{
            1:{
                respuesta: "Incluir leguminosas como frijoles y lentejas en tus comidas.",
                tipo: true
                },
            2:{
                respuesta :"Comer carne todos los días.",
                tipo: false
            },
            3: {
                respuesta: "Consumir productos lácteos exclusivamente.",
                tipo: false
            },
            4:{
                respuesta: "Comprar alimentos procesados.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "14. ¿Cuál de las siguientes afirmaciones es cierta sobre la proteína vegetal?",
        "respuestas":{
            1:{
                respuesta: "Puede encontrarse en una variedad de alimentos como leguminosas, nueces y tofu.",
                tipo: true
                },
            2:{
                respuesta :"Es exclusiva de la carne y los productos lácteos.",
                tipo: false
            },
            3: {
                respuesta: "Es más cara que la proteína animal.",
                tipo: false
            },
            4:{
                respuesta: "Debe evitarse en una dieta equilibrada.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "15. ¿Qué beneficios aporta el consumo regular de leguminosas, según las Guías Alimentarias colombianas?",
        "respuestas":{
            1:{
                respuesta: "Ayuda a prevenir la obesidad y aporta fibra,proteína y otros nutrientes esenciales.",
                tipo: true
                },
            2:{
                respuesta : "No ayuda a prevenir la obesidad.",
                tipo: false
            },
            3: {
                respuesta: "Promueve el consumo de carnes rojas.",
                tipo: false
            },
            4:{
                respuesta: "No aporta fibra, proteína y otros nutrientes esenciales.",
                tipo: false
            }
        }
    },
}

let preguntasToboganNutricion3 = {
    1:{
        "pregunta": "16. ¿Qué hace que la proteína de origen vegetal sea un poco menos digestible?",
        "respuestas":{
            1:{
                respuesta: "Micronutrientes propios de las leguminosas.",
                tipo: true
                },
            2:{
                respuesta : "El aceite en que cocinamos.",
                tipo: false
            },
            3: {
                respuesta: "Los productos ultraprocesados que compramos.",
                tipo: false
            },
            4:{
                respuesta: "Los diferentes colores de los vegetales.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "17. Diga un método de cocina que aumente la digestibilidad de las proteínas de origen vegetal",
        "respuestas":{
            1:{
                respuesta: "La cocción con calor.",
                tipo: true
                },
            2:{
                respuesta : "La fritura con aceite.",
                tipo: false
            },
            3: {
                respuesta: "Cortarlos y picarlos finamente.",
                tipo: false
            },
            4:{
                respuesta: "Ponerlos al sol antes de comerlos.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "18. ¿Por qué es importante cocinar las leguminosas?",
        "respuestas":{
            1:{
                respuesta: "Porque mejoramos la absorción de la proteína que esta nos aporta en nuestro organismo.",
                tipo: true
                },
            2:{
                respuesta :"Para aumentar la fibra y así la indigestión que esta nos da.",
                tipo: false
            },
            3: {
                respuesta: "Porque así el sabor se vuelve mas acido y esto aumenta las vitaminas.",
                tipo: false
            },
            4:{
                respuesta: "Cambia de color y así se vuelve más rica.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "19. ¿Por qué es importante consumir una amplia variedad de leguminosas?",
        "respuestas":{
            1:{
                respuesta: "Asegura que obtengamos una mayor cantidad de proteína.",
                tipo: true
                },
            2:{
                respuesta :"Hace que tu IMC se mayor.",
                tipo: false
            },
            3: {
                respuesta: "Hace que las uñas se vuelvan más quebradizas.",
                tipo: false
            },
            4:{
                respuesta: "Hace que seamos más lentos.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "20. Una de las muchas propiedades de las proteínas de origen vegetal es:",
        "respuestas":{
            1:{
                respuesta: "Pueden ayudarte a reducir el colesterol LDL.",
                tipo: true
                },
            2:{
                respuesta :"Pueden enfermarte.",
                tipo: false
            },
            3: {
                respuesta: "Pueden hacer que se te caiga el cabello.",
                tipo: false
            },
            4:{
                respuesta: "Pueden quitarte energía para hacer deporte.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "21. ¿Por qué debe de remojarse las leguminosas de un día para el otro?",
        "respuestas":{
            1:{
                respuesta: "Para eliminar antinutrientes y mejorar el aporte de proteína.",
                tipo: true
                },
            2:{
                respuesta :"Para facilitar la servida.",
                tipo: false
            },
            3: {
                respuesta: "Para evitar que tengan animales.",
                tipo: false
            },
            4:{
                respuesta: "No se necesitan remojar.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "22. ¿Por qué debe remojarse el carve antes de ser cocinado?",
        "respuestas":{
            1:{
                respuesta: "Se mejora su sabor y su textura, además, el grano se hidrata.  ",
                tipo: true
                },
            2:{
                respuesta :"No es necesario remojarse.",
                tipo: false
            },
            3: {
                respuesta: "Como es un vegetal dicho procedimiento no es necesario.",
                tipo: false
            },
            4:{
                respuesta: "Ninguna de las anteriores.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "23. Seleccione de qué manera podrían consumirse los frijoles en nuestros hogares:",
        "respuestas":{
            1:{
                respuesta: "Cocinados verdes o secos.",
                tipo: true
                },
            2:{
                respuesta :"Verdes en ensaladas.",
                tipo: false
            },
            3: {
                respuesta: "Como acompañantes de postres y salsas.",
                tipo: false
            },
            4:{
                respuesta: "Igual que consumimos el maní.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "24. Si tuvieras que escoger entre varias fuentes de proteína...",
        "respuestas":{
            1:{
                respuesta: "Escogería los garbanzos ya que son muy económicos y fáciles de preparar.",
                tipo: true
                },
            2:{
                respuesta :"Escogería la carne porque es deliciosa y barata.",
                tipo: false
            },
            3: {
                respuesta: "Optaría por un embutido dado que es más económico y saludable.",
                tipo: false
            },
            4:{
                respuesta: "No me parece importante el consumo de proteína.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "25. Seleccione de los siguientes enunciados, una de las razones por la que se deben consumir Proteínas de origen vegetal:",
        "respuestas":{
            1:{
                respuesta: "Son más económicas por lo que podemos adquirirlas más fácilmente en nuestros hogares.",
                tipo: true
                },
            2:{
                respuesta :"Al poder consumir los frijoles y las lentejas crudas obtenemos un mayor aporte de la proteico.",
                tipo: false
            },
            3: {
                respuesta: "Realmente no deberían consumirse dado que son dañinas para nuestro crecimiento.",
                tipo: false
            },
            4:{
                respuesta: "Da lo mismo si la consumimos o no.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "26. ¿Cuál de los siguientes alimentos son 3 alternativas para reemplazar nutricionalmente la proteína de origen animal?",
        "respuestas":{
            1:{
                respuesta: "Lentejas, maní, frijoles.",
                tipo: true
                },
            2:{
                respuesta: "Cereales, pastas y panela.",
                tipo: false
            },
            3: {
                respuesta: "Frutas, agua, leche.",
                tipo: false
            },
            4:{
                respuesta: "No existe manera.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "27. Son tres beneficios de consumir leguminosas:",
        "respuestas":{
            1:{
                respuesta: "Tiene fibra, previenen el cáncer de colon y facilitan la digestión.",
                tipo: true
                },
            2:{
                respuesta :"Son dulces, duran mucho y ayudan a la hidratación.",
                tipo: false
            },
            3: {
                respuesta: "Dan saciedad, son costosas y son difíciles de conseguir.",
                tipo: false
            },
            4:{
                respuesta: "Tiene fibra, ayudan a almacenar la grasa y dan energía.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "28. Dentro de nuestra cultura que alternativas tenemos para reemplazar la proteína de origen animal:",
        "respuestas":{
            1:{
                respuesta: "Preparaciones como los frijoles o las lentejas son muy comunes en nuestra casa.",
                tipo: true
                },
            2:{
                respuesta :"Los paisas solo consumimos proteína de origen animal.",
                tipo: false
            },
            3: {
                respuesta: "Las ensaladas y guisos.",
                tipo: false
            },
            4:{
                respuesta: "Los productos de paquete o enlatados.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "29. Si la finalidad es consumir alimentos que nos aporten proteínas y que sean de bajo costo:",
        "respuestas":{
            1:{
                respuesta: "Alimentos como frijoles, garbanzos y lentejas.",
                tipo: true
                },
            2:{
                respuesta :"Podemos optar por la carne que ciertamente es muy barata.",
                tipo: false
            },
            3: {
                respuesta: "Los embutidos tienen un alto valor proteico.",
                tipo: false
            },
            4:{
                respuesta: "Todo esta muy caro últimamente, así que es imposible consumirlo.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "30. ¿Cuál enunciado es correcto?",
        "respuestas":{
            1:{
                respuesta: "Las leguminosas tienen un buen aporte de fibra y proteínas.",
                tipo: true
                },
            2:{
                respuesta :"Las legumbres debido al aporte de fibra pueden dar indigestión.",
                tipo: false
            },
            3: {
                respuesta: "Las vitaminas y minerales que nos aportan las leguminosas son realmente insignificantes.",
                tipo: false
            },
            4:{
                respuesta: "No sé qué son las leguminosas.",
                tipo: false
            }
        }
    },
}

let preguntasTurnoExtraNutricion3 = {
    1:{
        "pregunta": "31. ¿Cuál enunciado NO es correcto?",
        "respuestas":{
            1:{
                respuesta: "La proteína animal no se puede reemplazar.",
                tipo: true
                },
            2:{
                respuesta :"Las leguminosas nos aportan fibra.",
                tipo: false
            },
            3: {
                respuesta: "Las leguminosas contienen mucha proteína.",
                tipo: false
            },
            4:{
                respuesta: "Las leguminosas contienen micronutrientes .",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "32. ¿Qué recomendación le daríamos a nuestra familia cuando estén cocinando?",
        "respuestas":{
            1:{
                respuesta: "Combinar los cereales como el arroz con las leguminosas como los frijoles y las lentejas.",
                tipo: true
                },
            2:{
                respuesta :"No combinar las leguminosas con otros alimentos.",
                tipo: false
            },
            3: {
                respuesta: "No cocinar las leguminosas dado que esto altera su sabor.",
                tipo: false
            },
            4:{
                respuesta: "No se cocinar, así que no me importa que hagan.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": " 33. ¿Cómo podríamos aumentar el aporte de proteína de las leguminosas?",
        "respuestas":{
            1:{
                respuesta: "Consumiéndola junto con cereales como el arroz.",
                tipo: true
                },
            2:{
                respuesta :"Cambiándola con carne de cerdo.",
                tipo: false
            },
            3: {
                respuesta: "Asándola al vapor con lentejas.",
                tipo: false
            },
            4:{
                respuesta: "d.	Preferiblemente cruda y sin aditivos.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "34. Seleccione la mejor manera de almacenar las leguminosas:",
        "respuestas":{
            1:{
                respuesta: "En un lugar fresco y seco donde no se contamine con nada.",
                tipo: true
                },
            2:{
                respuesta :"En la nevera junto con las frutas.",
                tipo: false
            },
            3: {
                respuesta: "En la alacena con los jabones y productos de limpieza.",
                tipo: false
            },
            4:{
                respuesta: "No necesitan almacenarse debido a que estas nunca ni se dañan ni se contaminan.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "35. Una opción muy económica de reemplazar la proteína animal sería:",
        "respuestas":{
            1:{
                respuesta: "Utilizar el carve en combinación con cereales como el arroz.",
                tipo: true
                },
            2:{
                respuesta :"Reemplazarla por embutidos.",
                tipo: false
            },
            3: {
                respuesta: "Es imposible de reemplazar.",
                tipo: false
            },
            4:{
                respuesta: "El uso de ultraprocesados sería lo mas viable.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "36. ¿Qué alimento No sugiere el plato saludable para Colombia?",
        "respuestas":{
            1:{
                respuesta: "Los ultraprocesados.",
                tipo: true
                },
            2:{
                respuesta :"Los lácteos.",
                tipo: false
            },
            3: {
                respuesta: "Los vegetales.",
                tipo: false
            },
            4:{
                respuesta: "Las leguminosas.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "37. ¿Cuál de las siguientes afirmaciones es cierta sobre la proteína vegetal?",
        "respuestas":{
            1:{
                respuesta: "Es más amigable con el medio ambiente.",
                tipo: true
                },
            2:{
                respuesta :"Contamina mucho el medio ambiente.",
                tipo: false
            },
            3: {
                respuesta: "Es menos amigable debido a su producción en masa.",
                tipo: false
            },
            4:{
                respuesta: "Contamina mucho el medio ambiente y es menos amigable debido a su producción aislada.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "38. ¿Cuál sería la importancia de las leguminosas en nuestra dieta?",
        "respuestas":{
            1:{
                respuesta: "Permiten reemplazar la proteína de origen animal.",
                tipo: true
                },
            2:{
                respuesta :"Ayudan al crecimiento de las uñas y el cabello.",
                tipo: false
            },
            3: {
                respuesta: "Deben evitarse en una dieta equilibrada.",
                tipo: false
            },
            4:{
                respuesta: "Ninguna respuesta es correcta.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "39. Seleccione la afirmación correcta:",
        "respuestas":{
            1:{
                respuesta: "La proteína de soya además de económica aporta todos los aminoácidos esenciales.",
                tipo: true
                },
            2:{
                respuesta :"La proteína de soya contine antinutrientes ricos en fibra.",
                tipo: false
            },
            3: {
                respuesta: "La soya aporta grandes cantidades de contaminantes.",
                tipo: false
            },
            4:{
                respuesta: "La proteína de soya mejora la digestión.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "40. ¿Qué ventajas tiene el uso de las leguminosas en la cocina?",
        "respuestas":{
            1:{
                respuesta: "Economía y variedad de preparaciones saludables.",
                tipo: true
                },
            2:{
                respuesta :"Todas las respuestas son correctas.",
                tipo: false
            },
            3: {
                respuesta: "Es menos agresiva para el organismo.",
                tipo: false
            },
            4:{
                respuesta: "No es recomendado su uso.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "41. Económicamente hablando, ¿qué sería más económico producir?",
        "respuestas":{
            1:{
                respuesta: "Los cultivos de leguminosas.",
                tipo: true
                },
            2:{
                respuesta :"El ganado de carne, porque la res no come nada.",
                tipo: false
            },
            3: {
                respuesta: "El ganado lechero, porque la leche no se daña.",
                tipo: false
            },
            4:{
                respuesta: "Los cultivos de árboles frutales.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "42. ¿Por qué recomendarías a tus padres comprar y cocinar leguminosas?",
        "respuestas":{
            1:{
                respuesta: "Es más económico y se pueden preparar mayor variedad de platos saludables.",
                tipo: true
                },
            2:{
                respuesta :"Es una opción más amigable con su bolsillo.",
                tipo: false
            },
            3: {
                respuesta: "No lo recomendaría.",
                tipo: false
            },
            4:{
                respuesta: "Es más costosa y poco rentable.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "43. ¿Por qué se debería reemplazar la proteína animal por proteína de origen vegetal?",
        "respuestas":{
            1:{
                respuesta: "Porque permite ser más fácilmente almacenada, es más económica y permite una mayor variedad de platos en la cocina.",
                tipo: true
                },
            2:{
                respuesta :"No tiene sentido reemplazarla.",
                tipo: false
            },
            3: {
                respuesta: "Difícilmente se pueden obtener los mismos beneficios.",
                tipo: false
            },
            4:{
                respuesta: "Porque resulta ser una opción más económica.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "44. Una opción de consumo de soya es:",
        "respuestas":{
            1:{
                respuesta: "Los aislados de soya y el carve.",
                tipo: true
                },
            2:{
                respuesta :"La carne.",
                tipo: false
            },
            3: {
                respuesta: "Soya cruda.",
                tipo: false
            },
            4:{
                respuesta: "Todas son correctas.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "45. Seleccione la respuesta correcta:",
        "respuestas":{
            1:{
                respuesta: "El hummus es una opción saludable y económica para consumir los garbanzos.",
                tipo: true
                },
            2:{
                respuesta :"Los garbanzos solo se pueden consumir en sopa",
                tipo: false
            },
            3: {
                respuesta: "Los garbanzos no aportan mas que fibra al organismo.",
                tipo: false
            },
            4:{
                respuesta: "Los garbanzos son muy duros y por eso no se recomienda su consumo.",
                tipo: false
            }
        }
    },
}




let preguntasEscaleraNutricion4 = {
    1:{
        "pregunta": "1.	¿Qué es un antioxidante?",
        "respuestas":{
            1:{
                respuesta: "Sustancia química que impide la formación de la oxidación celular.",
                tipo: true
                },
            2:{
                respuesta :"Proteína que ayuda a la oxidación celular.",
                tipo: false
            },
            3: {
                respuesta: "Sustancia química que ayuda a envejecer la célula.",
                tipo: false
            },
            4:{
                respuesta: "Sustancia que forma aminoácidos.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "2.	¿Cuáles son los principales alimentos fuente de antioxidante?",
        "respuestas":{
            1:{
                respuesta: "Frutas y verduras.",
                tipo: true
                },
            2:{
                respuesta :"Lácteos y carne.",
                tipo: false
            },
            3: {
                respuesta: "Frutas y lácteos.",
                tipo: false
            },
            4:{
                respuesta: "Carne y verduras.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "3.	¿Cuál es la porción indicada de consumo de frutas y verduras en el día para Colombia?",
        "respuestas":{
            1:{
                respuesta: "Cinco porciones al día.",
                tipo: true
                },
            2:{
                respuesta: "Dos porciones en cada comida.",
                tipo: false
            },
            3: {
                respuesta: "Tres porciones al día.",
                tipo: false
            },
            4:{
                respuesta: "Solo en el almuerzo.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "4.	¿Por qué es importante consumir la mayor cantidad de frutas y verduras con cáscara?",
        "respuestas":{
            1:{
                respuesta: "Por el aporte de fibra que ayuda al sistema digestivo.",
                tipo: true
                },
            2:{
                respuesta :"Porque ayuda a la vitalidad del cuerpo.",
                tipo: false
            },
            3: {
                respuesta: "Por el aporte al sistema cardiovascular.",
                tipo: false
            },
            4:{
                respuesta: "Porque ayuda a los riñones a la eliminación de toxinas.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "5.	¿Qué enfermedades se pueden prevenir con el consumo de frutas y verduras?",
        "respuestas":{
            1:{
                respuesta: "Enfermedades del miocardio y los accidentes cerebrovasculares.",
                tipo: true
                },
            2:{
                respuesta :"Enfermedades del sistema digestivo.",
                tipo: false
            },
            3: {
                respuesta: "Enfermedades del sistema renal.",
                tipo: false
            },
            4:{
                respuesta: "Enfermedades del sistema neuronal.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "6.	Los antioxidantes ayudan a la prevención de las siguientes enfermedades:",
        "respuestas":{
            1:{
                respuesta: "Cáncer, alzheimer y enfermedades crónicas.",
                tipo: true
                },
            2:{
                respuesta :"Gastritis, neumonía y varices.",
                tipo: false
            },
            3: {
                respuesta: "Parkinson, cáncer, y rinitis.",
                tipo: false
            },
            4:{
                respuesta: "Diabetes, Hipoglucemia y gastroenteritis.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "7.	¿Por qué el consumo de frutas y verduras ayuda a la prevención del sobrepeso y la obesidad?",
        "respuestas":{
            1:{
                respuesta: "Por su aporte de fibra y la disminución de la densidad energética de la dieta.",
                tipo: true
                },
            2:{
                respuesta :"Porque los aminoácidos ayudan al no envejecimiento de la célula.",
                tipo: false
            },
            3: {
                respuesta: "Porque previene enfermedades del aparato digestivo.",
                tipo: false
            },
            4:{
                respuesta: "Porque ayuda a subir los niveles de sobrepeso y obesidad .",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "8. ¿Cómo se recomienda consumir las frutas y las verduras para que sean absorbidas y aprovechadas por el organismo?",
        "respuestas":{
            1:{
                respuesta: "Crudas.",
                tipo: true
                },
            2:{
                respuesta :"Cocidas.",
                tipo: false
            },
            3: {
                respuesta: "Fritas.",
                tipo: false
            },
            4:{
                respuesta: "Horneadas.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "9.	Consumir frutas y verduras con variedad de colores significa que:",
        "respuestas":{
            1:{
                respuesta: "Se garantiza el aporte de variedad de nutrientes.",
                tipo: true
                },
            2:{
                respuesta :"Aporta nutrientes específicos.",
                tipo: false
            },
            3: {
                respuesta: "No garantiza el aporte de nutrientes.",
                tipo: false
            },
            4:{
                respuesta: "Ninguna de las anteriores.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "10. ¿Para qué sirven las frutas  y verduras de color verde? ",
        "respuestas":{
            1:{
                respuesta: "Promueven el funcionamiento celular.",
                tipo: true
                },
            2:{
                respuesta :"Promueve la producción de proteínas.",
                tipo: false
            },
            3: {
                respuesta: "Ayuda a los diferentes sistemas del cuerpo humano.",
                tipo: false
            },
            4:{
                respuesta: "Porque son ricas en vitaminas A y B.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "11. Partiendo que las frutas y verduras de color verde son fuentes de vitamina C y ayudan al funcionamiento, crecimiento y reparación celular, podríamos decir que:",
        "respuestas":{
            1:{
                respuesta: "Previenen el cáncer y ayudan a la reparación de los tejidos.",
                tipo: true
                },
            2:{
                respuesta :"No garantiza el aporte de nutrientes.",
                tipo: false
            },
            3: {
                respuesta: "Promueve la oxidación celular.",
                tipo: false
            },
            4:{
                respuesta: "No garantiza el buen funcionamiento celular.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "12. ¿Qué son los radicales libres? ",
        "respuestas":{
            1:{
                respuesta: "Moléculas cuya producción debe ser controlada para evitar efectos negativos.",
                tipo: true
                },
            2:{
                respuesta :"Moléculas que sólo se producen cada semana.",
                tipo: false
            },
            3: {
                respuesta: "Agentes del organismo que son nocivos para la salud.",
                tipo: false
            },
            4:{
                respuesta: "Moléculas que entre mayor sea su producción mayores beneficios trae al organismo.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "13. ¿Qué ayuda a neutralizar los radicales libres? ",
        "respuestas":{
            1:{
                respuesta: "Los antioxidantes.",
                tipo: true
                },
            2:{
                respuesta :"Las proteínas.",
                tipo: false
            },
            3: {
                respuesta: "Las vitaminas .",
                tipo: false
            },
            4:{
                respuesta: "Los minerales.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "14. ¿Cuáles son los principales compuestos de las frutas amarillas o naranjas? ",
        "respuestas":{
            1:{
                respuesta: "Betacarotenos y vitamina A.",
                tipo: true
                },
            2:{
                respuesta :"Radicales libres y vitamina B.",
                tipo: false
            },
            3: {
                respuesta: "Lípidos y vitamina C.",
                tipo: false
            },
            4:{
                respuesta: "Colesterol y vitamina D.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "15. ¿Beneficios de los betacarotenos y de la vitamina A ?",
        "respuestas":{
            1:{
                respuesta: "Fortalecen el sistema inmune y promueven la salud visual.",
                tipo: true
                },
            2:{
                respuesta : "Fortalecen el sistema nervioso.",
                tipo: false
            },
            3: {
                respuesta: "Promueven la salud bucal .",
                tipo: false
            },
            4:{
                respuesta: "Fortalece la salud de la piel.",
                tipo: false
            }
        }
    },
}


let preguntasToboganNutricion4 = {
    1:{
        "pregunta": "16. ¿Cómo podemos consumir vitamina A y tener visión nocturna?",
        "respuestas":{
            1:{
                respuesta: "Comiendo zanahoria, mango y uchuvas.",
                tipo: true
                },
            2:{
                respuesta : "Comiendo espinaca, apio y limón.",
                tipo: false
            },
            3: {
                respuesta: "Comiendo uvas, moras y remolacha.",
                tipo: false
            },
            4:{
                respuesta: "Comiendo fresas, tomate y cerezas.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "17. Mencione la opción correcta con respecto a los betacarotenos:",
        "respuestas":{
            1:{
                respuesta: "Favorecen la salud de la piel.",
                tipo: true
                },
            2:{
                respuesta : "Promueve la flora intestinal.",
                tipo: false
            },
            3: {
                respuesta: "Ayuda a la salud del cabello.",
                tipo: false
            },
            4:{
                respuesta: "Son perjudiciales en altas cantidades.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": "18. ¿Cuál es el mejor método de cocción para consumir las verduras fuente de antioxidantes?",
        "respuestas":{
            1:{
                respuesta: "Salteado.",
                tipo: true
                },
            2:{
                respuesta :"Apanado.",
                tipo: false
            },
            3: {
                respuesta: "Horneado.",
                tipo: false
            },
            4:{
                respuesta: "Guisado.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "19. ¿Los frutas y verduras de color morado, qué antioxidante aportan? ",
        "respuestas":{
            1:{
                respuesta: "Flavonoides, que ayudan al fortalecimiento de la memoria.",
                tipo: true
                },
            2:{
                respuesta :"Proteínas, que ayudan al envejecimiento de la piel.",
                tipo: false
            },
            3: {
                respuesta: "Vitaminas, que ayuda a la salud visual.",
                tipo: false
            },
            4:{
                respuesta: "Colesterol HDL, que ayuda a la prevención de infartos.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "20. De las siguientes opciones, ¿cuál es la más saludable? ",
        "respuestas":{
            1:{
                respuesta: "Comer un salteado de verduras y pollo, con jugo de mango.",
                tipo: true
                },
            2:{
                respuesta :"Comer papitas fritas con salsa de tomate y carne asada.",
                tipo: false
            },
            3: {
                respuesta: "Comer pollo apanado con gaseosa.",
                tipo: false
            },
            4:{
                respuesta: "Comer hamburguesa con agua y queso derretido.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "21. ¿Por qué los antioxidantes pueden ser perjudiciales para la salud? ",
        "respuestas":{
            1:{
                respuesta: "Porque superan las dosis permitidas y tienen efectos adversos.",
                tipo: true
                },
            2:{
                respuesta :"Porque son fáciles de cocinar.",
                tipo: false
            },
            3: {
                respuesta: "Porque son muy económicos.",
                tipo: false
            },
            4:{
                respuesta: "Son excelentes para la salud.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "22. ¿Cuáles frutas y verduras  salen más económicas para consumirlas?",
        "respuestas":{
            1:{
                respuesta: "Las frutas que estén en cosecha.  ",
                tipo: true
                },
            2:{
                respuesta :"Las frutas exóticas.",
                tipo: false
            },
            3: {
                respuesta: "Las frutas y verduras compradas  en restaurantes.",
                tipo: false
            },
            4:{
                respuesta: "Ninguna de las respuestas es correcta.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "23. ¿Cuál es la forma más indicada para comer verduras? ",
        "respuestas":{
            1:{
                respuesta: "En ensaladas crudas.",
                tipo: true
                },
            2:{
                respuesta :"Verdes en ensaladas.",
                tipo: false
            },
            3:{
                respuesta: "Como acompañantes de postres y salsas.",
                tipo: false
            },
            4:{
                respuesta: "Igual que consumimos el maní.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "24. ¿Cuál es el antioxidante más conocido en las frutas cítricas como las naranjas? ",
        "respuestas":{
            1:{
                respuesta: "Vitamina C.",
                tipo: true
                },
            2:{
                respuesta :"Vitamina B.",
                tipo: false
            },
            3: {
                respuesta: "Vitamina D.",
                tipo: false
            },
            4:{
                respuesta: "Vitamina K.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "25. ¿Cuál de las siguientes verduras es rica en antioxidantes como el beta-caroteno, que es beneficioso para la visión? ",
        "respuestas":{
            1:{
                respuesta: "Zanahoria.",
                tipo: true
                },
            2:{
                respuesta :"Pimentón Rojo.",
                tipo: false
            },
            3: {
                respuesta: "Espinaca.",
                tipo: false
            },
            4:{
                respuesta: "Brócoli.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "26. ¿Por qué son importantes los antioxidantes en las frutas y verduras? ",
        "respuestas":{
            1:{
                respuesta: "Reducen la inflamación .",
                tipo: true
                },
            2:{
                respuesta: "Causan daño.",
                tipo: false
            },
            3: {
                respuesta: "Son responsables de alergias.",
                tipo: false
            },
            4:{
                respuesta: "Aumenta el riesgo de enfermedades.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "27. ¿Cómo pueden los antioxidantes en frutas y verduras benefician la salud del cerebro? ",
        "respuestas":{
            1:{
                respuesta: "Reduciendo la inflamación.",
                tipo: true
                },
            2:{
                respuesta :"Aumenta la presión arterial.",
                tipo: false
            },
            3: {
                respuesta: "Mejorando la digestión.",
                tipo: false
            },
            4:{
                respuesta: "Aumentando el riesgo de enfermedades cerebrales.",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "28. ¿Cuál de los siguientes no es una fruta antioxidante? ",
        "respuestas":{
            1:{
                respuesta: "Plátanos.",
                tipo: true
                },
            2:{
                respuesta :"Uvas.",
                tipo: false
            },
            3: {
                respuesta: "Manzanas.",
                tipo: false
            },
            4:{
                respuesta: "Fresas.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "29. ¿Por qué son importantes los antioxidantes en la dieta? ",
        "respuestas":{
            1:{
                respuesta: "Porque protegen las células .",
                tipo: true
                },
            2:{
                respuesta :"Porque causan enfermedades.",
                tipo: false
            },
            3: {
                respuesta: "Porque mejoran el sabor de los alimentos.",
                tipo: false
            },
            4:{
                respuesta: "Porque aumentan el estrés.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "30. ¿Qué antioxidante en las frutas y verduras es beneficioso para la piel?",
        "respuestas":{
            1:{
                respuesta: "Vitamina C.",
                tipo: true
                },
            2:{
                respuesta :"Vitamina A.",
                tipo: false
            },
            3: {
                respuesta: "Vitamina E.",
                tipo: false
            },
            4:{
                respuesta: "Vitamina K.",
                tipo: false
            }
        }
    },
}


let preguntasTurnoExtraNutricion4 = {
    1:{
        "pregunta": "31. ¿Cuál es uno de los beneficios comunes de la fibra en frutas y verduras antioxidantes? ",
        "respuestas":{
            1:{
                respuesta: "Reduce la inflamación.",
                tipo: true
                },
            2:{
                respuesta :"Aumenta la presión arterial.",
                tipo: false
            },
            3: {
                respuesta: "Causa alergias.",
                tipo: false
            },
            4:{
                respuesta: "Aumenta el riesgo de diabetes.",
                tipo: false
            }
        }
    },
    2:{
        "pregunta": "32. ¿Cómo pueden los antioxidantes en frutas y verduras ayudar a prevenir enfermedades como el cáncer? ",
        "respuestas":{
            1:{
                respuesta: "Protegiendo el ADN de daños.",
                tipo: true
                },
            2:{
                respuesta :"Aumentando el riesgo de mutaciones celulares.",
                tipo: false
            },
            3: {
                respuesta: "Promoviendo la inflamación.",
                tipo: false
            },
            4:{
                respuesta: "Reduciendo el consumo de frutas y verduras.",
                tipo: false
            }
        }
    },
    3:{
        "pregunta": " 33. ¿Qué frutas y qué verduras son ricos en antioxidantes?",
        "respuestas":{
            1:{
                respuesta: "Fresas, arándanos, brócolis, espinaca.",
                tipo: true
                },
            2:{
                respuesta: "Coco, papa, papa criolla.",
                tipo: false
            },
            3: {
                respuesta: "Carne de res.",
                tipo: false
            },
            4:{
                respuesta: "Agua de frutas.",
                tipo: false
            }
        }
    },
    4:{
        "pregunta": "34. ¿Qué antioxidante ayuda a la salud de la piel para que permanezca radiante?",
        "respuestas":{
            1:{
                respuesta: "Vitamina C.",
                tipo: true
                },
            2:{
                respuesta :"Minerales.",
                tipo: false
            },
            3: {
                respuesta: "Proteínas.",
                tipo: false
            },
            4:{
                respuesta: "Grasas.",
                tipo: false
            }
        }
    },
    5:{
        "pregunta": "35. ¿Qué verduras ayudan a la salud visual?",
        "respuestas":{
            1:{
                respuesta: "Ahuyama, zanahoria y tomate.",
                tipo: true
                },
            2:{
                respuesta :"Limón, plátano verde y agua.",
                tipo: false
            },
            3: {
                respuesta: "Postre de coco.",
                tipo: false
            },
            4:{
                respuesta: "Salteado con salsa de tomate.",
                tipo: false
            }
        }
    },
    6:{
        "pregunta": "36. ¿Qué beneficio tienen los antioxidantes para el corazón? ",
        "respuestas":{
            1:{
                respuesta: "Ayuda a mantener los niveles arteriales estables ya que evita la inflamación.",
                tipo: true
                },
            2:{
                respuesta :"Disminuye el tamaño del corazón.",
                tipo: false
            },
            3: {
                respuesta: "Aumenta la presión arterial.",
                tipo: false
            },
            4:{
                respuesta: "Contribuye a la obesidad.",
                tipo: false
            }
        }
    },
    7:{
        "pregunta": "37. ¿Cómo se aprovecha mejor la fibra de las frutas y verduras? ",
        "respuestas":{
            1:{
                respuesta: "Se deben comer con cáscara siempre que se pueda.",
                tipo: true
                },
            2:{
                respuesta :"Se deben hervir hasta que solo quede agua.",
                tipo: false
            },
            3: {
                respuesta: "Se deben freír.",
                tipo: false
            },
            4:{
                respuesta: "Se deben pelar y solo comer las semillas.",
                tipo: false
            }
        }
    },
    8:{
        "pregunta": "38. ¿Qué se debe consumir para disminuir la inflamación de la artritis?",
        "respuestas":{
            1:{
                respuesta: "Frutas y verduras.",
                tipo: true
                },
            2:{
                respuesta :"Comida frita y con salsas.",
                tipo: false
            },
            3: {
                respuesta: "Comidas rápidas.",
                tipo: false
            },
            4:{
                respuesta: "Comida cocinada.",
                tipo: false
            }
        }
    },
    9:{
        "pregunta": "39. ¿Qué se debe de consumir para el adecuado aprovechamiento de la fibra?",
        "respuestas":{
            1:{
                respuesta: "Agua.",
                tipo: true
                },
            2:{
                respuesta :"Grasas.",
                tipo: false
            },
            3: {
                respuesta: "Salsas.",
                tipo: false
            },
            4:{
                respuesta: "Ultraprocesados.",
                tipo: false
            }
        }
    },
    10:{
        "pregunta": "40. ¿Por qué las frutas y verduras ayudan a controlar los niveles de azúcar en la sangre?",
        "respuestas":{
            1:{
                respuesta: "Por su aporte de fibra.",
                tipo: true
                },
            2:{
                respuesta :"Por que aumentan los niveles de grasa en sangre.",
                tipo: false
            },
            3: {
                respuesta: "Aumenta la diabetes.",
                tipo: false
            },
            4:{
                respuesta: "Aumenta la presión en los riñones.",
                tipo: false
            }
        }
    },
    11:{
        "pregunta": "41. ¿Qué enfermedades cerebrales previenen los antioxidantes? ",
        "respuestas":{
            1:{
                respuesta: "Los accidentes cerebro vasculares y Alzhéimer.",
                tipo: true
                },
            2:{
                respuesta :"Los ojos rojos.",
                tipo: false
            },
            3: {
                respuesta: "Los parásitos intestinales.",
                tipo: false
            },
            4:{
                respuesta: "No resuelve nada.",
                tipo: false
            }
        }
    },
    12:{
        "pregunta": "42. ¿Por qué los flavonoides evitan el cáncer?",
        "respuestas":{
            1:{
                respuesta: "Por qué evitan el crecimiento de tumores.",
                tipo: true
                },
            2:{
                respuesta :"Porque hacen crecer el cabello.",
                tipo: false
            },
            3: {
                respuesta: "Ayudan a la cocción de los alimentos .",
                tipo: false
            },
            4:{
                respuesta: "Ayudan con el medio ambiente .",
                tipo: false
            }
        }
    },
    13:{
        "pregunta": "43. Si nos hablan de mutaciones celulares, entonces los antioxidantes evitan:",
        "respuestas":{
            1:{
                respuesta: "Cáncer.",
                tipo: true
                },
            2:{
                respuesta :"Pérdida de los dientes.",
                tipo: false
            },
            3: {
                respuesta: "Piojos.",
                tipo: false
            },
            4:{
                respuesta: "Aumento de sangre.",
                tipo: false
            }
        }
    },
    14:{
        "pregunta": "44. Al desinflamar las vías respiratorias, siempre se mantendrá bien:",
        "respuestas":{
            1:{
                respuesta: "Los pulmones.",
                tipo: true
                },
            2:{
                respuesta :"Los pies.",
                tipo: false
            },
            3: {
                respuesta: "El Hígado.",
                tipo: false
            },
            4:{
                respuesta: "El Intestino.",
                tipo: false
            }
        }
    },
    15:{
        "pregunta": "45. ¿Qué partes del cuerpo se benefician con los antioxidantes? ",
        "respuestas":{
            1:{
                respuesta: "Todos los órganos del cuerpo se benefician.",
                tipo: true
                },
            2:{
                respuesta :"Ninguna, solo necesitamos aire",
                tipo: false
            },
            3: {
                respuesta: "Ninguno órgano.",
                tipo: false
            },
            4:{
                respuesta: "Todas las respuestas son correctas.",
                tipo: false
            }
        }
    },
}



export { preguntasEscaleraNutricion, preguntasToboganNutricion, preguntasTurnoExtraNutricion, preguntasEscaleraNutricion2, preguntasTurnoExtraNutricion2, preguntasToboganNutricion2, preguntasToboganNutricion3, preguntasEscaleraNutricion3, preguntasTurnoExtraNutricion3, preguntasEscaleraNutricion4, preguntasToboganNutricion4, preguntasTurnoExtraNutricion4 };